import { motion } from "framer-motion";
import Button from "ui/atoms/Button/Button";
import * as a from "./animationConsts";

interface Props {
  onRequestBack: () => void;
}

export default function BackToBasicOptionsHeader({ onRequestBack }: Props) {
  return (
    <motion.div
      className="flex items-center justify-between"
      transition={{ duration: 0.3, delay: 0.1 }}
      initial={a.initial}
      animate={a.animate}
      exit={{
        ...a.exit,
        transition: { duration: 0.1, delay: 0, y: { delay: 0.5 } },
      }}
    >
      <div className="text-xl text-white">Advanced Options</div>

      <Button theme="default" onClick={onRequestBack}>
        Back
      </Button>
    </motion.div>
  );
}
